export default __webpack_public_path__ + "static/media/suzuki.5514f526.svg";